import { Story, Meta } from '@storybook/web-components';
import { html } from 'lit-html';
import './table-chart';

// More on default export: https://storybook.js.org/docs/web-components/writing-stories/introduction#default-export
export default {
  title: 'gsmlg/echarts/table',
  // More on argTypes: https://storybook.js.org/docs/web-components/api/argtypes
  argTypes: {},
} as Meta;

export interface ElementProps {
  width: string;
  height: string;
  loading: boolean;
  renderer: 'svg' | 'canvas';
  titles: object[];
  data: object[];
}

// More on component templates: https://storybook.js.org/docs/web-components/writing-stories/introduction#using-args
const Template: Story<ElementProps> = ({
  width,
  height,
  loading,
  renderer,
  data,
  titles,
}) =>
  html`<div style="width: ${width}; height: ${height};">
    <echarts-table
      renderer=${renderer}
      ?loading=${loading}
      data=${JSON.stringify(data)}
      titles=${JSON.stringify(titles)}
    ></echarts-table>
  </div>`;

export const Table = Template.bind({});

Table.args = {
  width: '100%',
  height: '480px',
  loading: false,
  renderer: 'canvas',
  titles: [
    { key: 'name', name: 'Name', width: 0.3 },
    { key: 'value', name: 'Value', width: 0.4 },
  ],
  data: [
    {
      name: '2018',
      value: 39,
    },
    {
      name: '2019',
      value: 68,
    },
    {
      name: '2020',
      value: 41,
    },
    {
      name: '2021',
      value: 102,
    },
    {
      name: '2022',
      value: 98,
    },
  ],
};

export const HugeData = Template.bind({});

const sampleData: { year: number; count: number }[] = [];
for (let i = 1; i <= 2022; i += 1) {
  sampleData.push({
    year: i,
    count: Math.round(Math.random() * 1000000),
  });
}

HugeData.args = {
  width: '600px',
  height: '480px',
  loading: false,
  renderer: 'svg',
  titles: [
    { key: 'year', name: 'Year', width: 0.45 },
    { key: 'count', name: 'Count', width: 0.45 },
  ],
  data: sampleData,
};
